document.addEventListener('DOMContentLoaded', function () {

  const words = document.querySelectorAll('.big-word');
  const tl = gsap.timeline({
    repeat: -1 // Loop
  });

  gsap.set(words, { // Initial stat
    xPercent: (index) => (index === 0 ? 0 : 100),
    opacity: (index) => (index === 0 ? 1 : 0)
  });

  words.forEach((word, index) => {
    const next = words[index + 1];
    if (next) {
      tl.to(word, {
        xPercent: -100,
        opacity: 0,
        delay: 2,
        duration: 0.2
      }).to(next, {xPercent: 0, opacity: 1}, "<");
      tl.to(words[0], {xPercent: 100})
    } else {
      // Back to first word
      tl.to(word, {xPercent: -100, opacity: 0, delay: 2, duration: 0.2}).fromTo(
        words[0],
        { // Initial stat
          xPercent: 100,
          opacity: 0
        },
        { // Back to initial stat
          xPercent: 0,
          opacity: 1,
          delay: 0.2,
          immediateRender: false // Wait for the animation ending
        },
        "<"
      );
    }
  });

})
